/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keyword_Optimizer_Status_MissingInputs */

const en_keyword_optimizer_status_missing = /** @type {(inputs: Keyword_Optimizer_Status_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Missing`)
};

const de_keyword_optimizer_status_missing = /** @type {(inputs: Keyword_Optimizer_Status_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Missing`)
};

const fr_keyword_optimizer_status_missing = /** @type {(inputs: Keyword_Optimizer_Status_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Missing`)
};

const es_keyword_optimizer_status_missing = /** @type {(inputs: Keyword_Optimizer_Status_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Missing`)
};

const it_keyword_optimizer_status_missing = /** @type {(inputs: Keyword_Optimizer_Status_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Missing`)
};

const nl_keyword_optimizer_status_missing = /** @type {(inputs: Keyword_Optimizer_Status_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Missing`)
};

const pl_keyword_optimizer_status_missing = /** @type {(inputs: Keyword_Optimizer_Status_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Missing`)
};

const fi_keyword_optimizer_status_missing = /** @type {(inputs: Keyword_Optimizer_Status_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Missing`)
};

const da_keyword_optimizer_status_missing = /** @type {(inputs: Keyword_Optimizer_Status_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Missing`)
};

const sv_keyword_optimizer_status_missing = /** @type {(inputs: Keyword_Optimizer_Status_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Missing`)
};

/**
* | output |
* | --- |
* | "Missing" |
*
* @param {Keyword_Optimizer_Status_MissingInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const keyword_optimizer_status_missing = /** @type {((inputs?: Keyword_Optimizer_Status_MissingInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keyword_Optimizer_Status_MissingInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_keyword_optimizer_status_missing(inputs)
	if (locale === "fr") return fr_keyword_optimizer_status_missing(inputs)
	if (locale === "es") return es_keyword_optimizer_status_missing(inputs)
	if (locale === "it") return it_keyword_optimizer_status_missing(inputs)
	if (locale === "nl") return nl_keyword_optimizer_status_missing(inputs)
	if (locale === "pl") return pl_keyword_optimizer_status_missing(inputs)
	if (locale === "fi") return fi_keyword_optimizer_status_missing(inputs)
	if (locale === "da") return da_keyword_optimizer_status_missing(inputs)
	if (locale === "sv") return sv_keyword_optimizer_status_missing(inputs)
	return en_keyword_optimizer_status_missing(inputs)
});